import React, {Fragment} from 'react'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {centeredText} from 'lib/styleguide/base.scss'
import img from './img.png'
import {getCurrentUser} from 'lib/utils'

export const PRINT_UPSELL_DIALOG = 'PRINT_UPSELL_DIALOG'

export const PrintUpsellDialog = ({routeId, onRequestClose}) => (
  <ModalOverlay
    maxWidth='900px'
    onRequestClose={onRequestClose}>
    <div style={{display: 'flex'}}>
      <div style={{flex: '1 1 50%', position: 'relative'}}>
        <img src={img} alt='print cuesheet' style={{maxWidth: '90%'}} />
      </div>
      <div style={{flex: '1 1 50%', display: 'flex', alignItems: 'center'}}>
        <div>
          <h2>PDF Maps & Cuesheets</h2>
          <p>
            Craft the perfect map with multiple size and orientation options, ordered
            points of interest, custom cues, and multiple map styles to choose from.
          </p>
          <CTA href='/choose_account?utm_campaign=choose_account&utm_medium=generic&utm_source=upsell_print'>Upgrade Now</CTA>
          <p className={centeredText}>
            <a href={`/routes/${routeId}/cue_sheet`} target='_blank'>No thanks, just take me to the basic cuesheet print page</a>
          </p>
          {getCurrentUser().eligibleForOnetimeTrial && <Fragment>
            <p>Interested in a 7 day free trial of all Premium features? No credit card required!</p>
            <CTA secondary href='/start_trial'>Start Trial Now</CTA>
          </Fragment>}
        </div>
      </div>
    </div>
  </ModalOverlay>
)
